import { render, staticRenderFns } from "./DataTableFixedHeader.vue?vue&type=template&id=4f4f9a22"
import script from "./DataTableFixedHeader.vue?vue&type=script&lang=js"
export * from "./DataTableFixedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports